<template>
    <aside class="layout-wing-view" v-if="isOpen">
        <!--header-->
        <header class="wing-title">
            <h2 class="title">{{$t('SETTING.WHITELIST.HEADER.ADD_RESOURCE')}}</h2>
            <div class="actions">
                <button type="button" class="buttons-icon"
                        data-type="ghost" data-size="l"
                        data-icon="close" data-trigger="close"
                        v-on:click="closeAddingResource">{{$t('LABEL.CLOSE')}}</button>
            </div>
        </header>
        <!--filter section-->
        <div>
            <fieldset class="setting-filter-resource">
                <div class="header">
                    <button type="button" class="btn-filter"
                            v-on:click="toggleResourceFilter"
                            v-bind:data-selected="selectedFilterKeys.length > 0">
                        {{$t('SETTING.WHITELIST.BUTTON.FILTER')}}
                    </button> <!-- data-selected attr 유/무-->
                    <div class="selected-items">
                        <span v-show="idx < 3" v-for="(filterItem, idx) of selectedFilterKeys" class="chip-filter-selected" :key="idx">
                            {{getRgn(filterItem)}}
                        </span>
                        <span class="actions">
                            <span v-if="selectedFilterKeys.length > 3" class="extra-count">{{ $t('SETTING.WHITELIST.LABEL.EA_MORE', {'cnt':selectedFilterKeys.length-3})}}<!--외 {0}개--></span>
                            <button type="button"
                                    class="buttons-icon"
                                    data-type="ghost"
                                    data-size="s"
                                    data-icon="clear"
                                    v-on:click="clearFilter">
                            </button>
                        </span>
                    </div>
                    <div class="actions">
                        <div class="info">
                            <span class="seperate">
                                <button type="button" class="buttons-icon" data-type="ghost" data-size="s" data-icon="info" data-trigger="tooltip-gnb"
                                        v-bind:title="$t('SETTING.WHITELIST.MESSAGE.FILTER_TOOLTIP')">{{$t('SETTING.WHITELIST.MESSAGE.FILTER_TOOLTIP')}}</button>
                            </span>
                        </div>
                        <div class="submit">
                            <strong class="txt-status" data-status="selected">{{ $t('SETTING.WHITELIST.LABEL.EA_SELECTED', {'cnt':selectedFilterKeys.length})}}</strong>
                            <button type="reset" class="buttons" data-type="ghost" data-size="s" v-on:click="clearFilter">{{$t('SETTING.WHITELIST.BUTTON.CLEAR')}}</button>
                            <span class="seperate">
                                <button type="button" class="buttons" data-type="line" data-size="s" v-on:click="toggleResourceFilter">{{ $t('COMMON.BUTTON.CAMEL.CANCEL')}}</button>
                                <button type="button" class="buttons" data-size="s" v-on:click="applyFilter">{{$t('SETTING.WHITELIST.BUTTON.APPLY')}}</button>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="filter-contents">
                    <fieldset class="filter-group">
                        <legend>{{$t('SETTING.WHITELIST.LABEL.VENDOR')}}</legend>
                        <dl class="hstack">
                            <dt>1. {{$t('SETTING.WHITELIST.LABEL.VENDOR')}}</dt>
                            <dd>
                                <CSelectBoxSingle
                                    v-if="cloudServiceOptions.length > 0"
                                    slctBoxId="select_filter_vendor"
                                    @onSelectChange="changeVendor($event.value)"
                                    :options="cloudServiceOptions"
                                    :preset="cloudServiceOptions[0]"
                                />
                            </dd>
                        </dl>
                    </fieldset>
                    <fieldset class="filter-group">
                        <legend>{{$t('SETTING.WHITELIST.LABEL.VENDOR')}}</legend>
                        <dl class="vstack">
                            <dt>
                                2. {{$t('SETTING.WHITELIST.LABEL.SELECT_FILTER')}}
                                <div class="actions">
                                    <button type="button"
                                            class="buttons"
                                            data-type="ghost"
                                            data-size="s"
                                            data-icon="plus"
                                            v-on:click="toggleAllDetailFilter(true)">
                                    {{$t('SETTING.WHITELIST.BUTTON.EXPAND_ALL')}}</button>
                                    <button type="button" class="buttons" data-type="ghost" data-size="s" data-icon="minus" v-on:click="toggleAllDetailFilter(false)">{{$t('SETTING.WHITELIST.BUTTON.COLLAPSE_ALL')}}</button>
                                </div>
                            </dt>
                            <dd>
                                <table class="tbl-filter-items">
                                    <caption>{{$t('SETTING.WHITELIST.LABEL.SELECT_ITEM')}}</caption>
                                    <colgroup>
                                        <col style="width: 140px;">
                                    </colgroup>
                                    <thead>
                                    <tr>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <th>
                                            <input type="checkbox"
                                                   id="account-all"
                                                   name="account-all"
                                                   class="checkbox"
                                                   v-model="isSelectAllAccount">
                                            <label for="account-all">{{$t('FILTER.ACCOUNT')}} ({{accountKeys.length}}/{{accounts.length}})</label>
                                        </th>
                                        <td>
                                            <button
                                                    v-show="accounts.length > 4"
                                                    type="button"
                                                    class="buttons-icon"
                                                    data-type="ghost"
                                                    data-size="s"
                                                    data-icon="toogle-plus"
                                                    v-bind:data-expand="accounts.length < 3 || isExpandAccountFilter ? true : null"
                                                    v-on:click="toggleDetailFilter('account')">collapse / expand</button>
                                        </td>
                                        <td>
                                            <ul class="list-items" v-bind:data-expand="isExpandAccountFilter ? true : null">
                                                <li v-for="(acnt, index) of accounts" :key="index">
                                                    <input type="checkbox"
                                                           name="account"
                                                           class="chip-filter"
                                                           v-bind:id="acnt"
                                                           v-model="accountKeys" :value="acnt">
                                                    <label :for="acnt" :title="acnt">{{acnt}}</label>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <input type="checkbox"
                                                   id="region-all"
                                                   name="region-all"
                                                   class="checkbox"
                                                   v-model="isSelectAllRegion">
                                            <label for="region-all">{{$t('FILTER.REGION')}} ({{regionKeys.length}}/{{regions.length}})</label>
                                        </th>
                                        <td>
                                            <button v-show="regions.length > 4"
                                                    type="button"
                                                    class="buttons-icon"
                                                    data-type="ghost"
                                                    data-size="s"
                                                    data-icon="toogle-plus"
                                                    v-bind:data-expand="regions.length < 3 || isExpandRegionFilter ? true : null"
                                                    v-on:click="toggleDetailFilter('region')">collapse / expand</button>
                                        </td>
                                        <td>
                                            <ul class="list-items" v-bind:data-expand="isExpandRegionFilter ? true : null">
                                                <li v-for="(rgn, index) of regions" :key="index">
                                                        <input type="checkbox"
                                                               name="region"
                                                               class="chip-filter"
                                                               v-bind:id="rgn"
                                                               v-model="regionKeys" :value="rgn">
                                                    <label :for="rgn" :title="rgn">{{getRgn(rgn)}}</label>
                                                </li>

                                            </ul>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>
                                            <input type="checkbox" id="product-all" name="product-all" class="checkbox"
                                                   v-model="isSelectAllProduct">
                                            <label for="product-all">{{$t('FILTER.PRODUCT')}} ({{productKeys.length}}/{{products.length}})</label>
                                        </th>
                                        <td>
                                            <button v-show="products.length > 4"
                                                    type="button" class="buttons-icon" data-type="ghost" data-size="s" data-icon="toogle-plus"
                                                    v-bind:data-expand="products.length < 3 || isExpandProductFilter ? true : null"
                                                    v-on:click="toggleDetailFilter('product')">collapse / expand</button>
                                        </td>
                                        <td>
                                            <ul class="list-items" v-bind:data-expand="isExpandProductFilter ? true : null">
                                                <li v-for="(prod, index) of products" :key="index">
                                                    <input type="checkbox" name="product"
                                                           class="chip-filter"
                                                           v-bind:id="prod"
                                                           v-model="productKeys"
                                                           :value="prod">
                                                    <label :for="prod" :title="prod">{{prod}}</label>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>

                            </dd>
                        </dl>
                    </fieldset>
                </div>
            </fieldset>
        </div>
        <!--resource list-->
        <div class="wing-contents">
            <div class="resource-list">
                <ResourceTable
                    :resourceList="resourceList"
                    :paging="paging"
                    :preSelectedItems="tempSlctRsrcKeys"
                    :callSetSearchKey="callSetSearchKey"
                    :callSetSortKey="callSetSortKey"
                    :callSetCurPage="callSetCurrentPage"
                    :callSetRowsPerPage="callSetRowsPerPage"
                    :preSortObject="preSortObject"
                    :isSideLoading="isSideLoading"
                    @onChecked="onResourceChecked($event)"
                />
            </div>
        </div>
        <footer class="wing-footer">
            <div class="wing-confirm" v-bind:data-invalid="totalSlctedRsrc.length > 0">
                <div class="wing-confirm-title">
                    <h2 class="title">{{$t('SETTING.WHITELIST.LABEL.FINAL_CONFIRM')}}</h2>
                    <p class="validation-message" v-if="totalSlctedRsrc.length === 0">{{$t('SETTING.WHITELIST.ERROR.RESOURCE_MONE_2')}}</p>
                </div>

                <div class="selected-resource">
                    <span class="key">{{$t('SETTING.WHITELIST.LABEL.SELECTED_RESOURCE')}}</span>
                    <strong class="value"> {{totalSlctedRsrc.length}}</strong>
                </div>
            </div>

            <div class="actions">
                <button type="button"
                        class="buttons"
                        v-on:click="closeAddingResource">
                    {{ $t('COMMON.BUTTON.CAMEL.CANCEL')}}</button>
                <button type="button"
                        class="buttons"
                        data-type="key"
                        v-on:click="addResourceToWhitelist"
                        v-bind:disabled="totalSlctedRsrc.length < 1">
                    {{ $t('COMMON.BUTTON.UPPER.OK')}}</button>
            </div>
        </footer>
    </aside>
</template>
<script>

import ResourceTable from "./ResourceTable.vue"
import CSelectBoxSingle from "../../common/OptionSelect/CSelectBoxSingle.vue";
import Pagination from "../../common/Pagination";
import {EventBus} from "../../common/event-bus";

export default {
    name: "AddingResourceComponent",
    components: {
        Pagination, CSelectBoxSingle, ResourceTable
    },
    props: {
        preSortObject: Object,
        callCloseARC: {
            type: Function,
            default: ()=>{}
        },
        isOpen: {
            type: Boolean,
            default: false
        },
        inUseVendors: {
            type: Array,
            default: ()=>[]
        },
        callUpdateSlctRsrc: {
            type: Function,
            default: ()=>{}
        },
        accounts: {
            type: Array,
            default() {
                return [];
            }
        },
        products: {
            type: Array,
            default() {
                return [];
            }
        },
        regions: {
            type: Array,
            default() {
                return [];
            }
        },
        callSetSortKey: Function,
        callSetSearchKey: Function,
        callAddResource: Function,
        callSetRowsPerPage: Function,
        callApplyFilterKeys: Function,
        callSetRowPerPage: Function,
        callSetVendorKey: Function,
        callSetCurrentPage: Function,
        paging: {
            type: Object,
            default() {return {}}
        },
        resourceList: Array,
        isSideLoading: Boolean,
    },
    data() {
        return {
            tempSlctRsrcValue: {},
            tempSlctRsrcKeys:{},
            totalSlctedRsrc: [],
            searchTxt: '',
            isExpandProductFilter: false,
            isExpandAccountFilter: false,
            isExpandRegionFilter: false,
            regionKeys: [],
            productKeys: [],
            accountKeys: [],
            cloudKey: null,
            selectedFilterKeys: [],
            recordPerPage: this.constants.NUM.RESOURCE_ROW_PER_PAGE,
            listNoRowsTemplate: `<p class='overlay-nodata'><span>${this.$t('COMMON.NO_DATA')}</span></p>`, //검색 결과가 없습니다.
        }
    },
    created: function(){
        EventBus.$on("changeLocale", e => {
            this.listNoRowsTemplate = `<p class='overlay-nodata'><span>${this.$t('COMMON.NO_DATA')}</span></p>`
        });
    },
    watch: {
        accountKeys() {
            this.selectFilterKeys();
        },
        regionKeys() {
            this.selectFilterKeys();
        },
        productKeys() {
            this.selectFilterKeys();
        },
        "paging.rowPerPage"() {
            this.totalSlctedRsrc = [];
            this.tempSlctRsrcKeys = {};
        }
    },
    computed: {
        cloudServiceOptions() {
            const vendors = [];
            this.inUseVendors.forEach(vndr=>{
                vendors.push({
                    key: vndr.CLOUD_VNDR_ID,
                    value: vndr.CLOUD_VNDR_NM,
                    vendor: this.Common.getVendorByKey(vndr.CLOUD_VNDR_ID)
                })
            });
            this.cloudKey = vendors[0].key;
            return vendors;
        },
        isSelectAllAccount: {
            get() {
                return (this.accountKeys.length === this.accounts.length) && this.accounts.length !== 0;
            },
            set(value) {
                let accounts = [];
                if (value) {
                    _.forEach(this.accounts, (account)=>{
                        accounts.push(account);
                    })
                }
                this.accountKeys = accounts;
            }
        },
        isSelectAllRegion : {
            get() {
                return (this.regionKeys.length === this.regions.length) && this.regions.length !== 0;
            },
            set(value) {
                let selected = []
                if (value) {
                    this.regions.forEach(function (rgn) {
                        selected.push(rgn)
                    })
                }
                this.regionKeys = selected;
            }
        },
        isSelectAllProduct : {
            get() {
                return (this.productKeys.length === this.products.length) && this.products.length !== 0;
            },
            set(value) {
                let selected = []
                if (value) {
                    this.products.forEach(function (prod) {
                        selected.push(prod)
                    })
                }
                this.productKeys = selected;
            }
        },
    },
    methods: {
        getRgn(rgn) {
            if (this.$te('COMMON.REGION.' + rgn)) {
                return this.$t('COMMON.REGION.' + rgn);
            }
            return rgn;
        },
        getSelectedResource() {
            const rsrc = Object.values(this.tempSlctRsrcValue);
            this.totalSlctedRsrc = rsrc.flat();
        },
        setRowPerPage(num) {
            if (num < 1) {
                num = 1;
                this.recordPerPage = 1;
            }
            this.callSetRowPerPage(num);
            this.resetFilter(true);
        },
        getAccountId(account) {
            return account.slice(0,account.indexOf('('));
        },
        selectFilterKeys: function() {
            let selectedKey = [].concat.apply(this.accountKeys, this.productKeys);
            selectedKey = [].concat.apply(selectedKey, this.regionKeys);
            this.selectedFilterKeys = selectedKey;
        },
        changeVendor(cloud) {
            this.resetFilter(true);
            this.cloudKey = cloud;
            this.callSetVendorKey(cloud);

        },
        addResourceToWhitelist() {
            this.callAddResource(this.totalSlctedRsrc);
            this.closeAddingResource();
        },
        // 리소스 추가 팝업에서 checkbox 클릭했을때 이벤트
        onResourceChecked(evt) {
            const selectedKey = evt.selectedItems;
            this.tempSlctRsrcKeys[this.paging.currentPage] = selectedKey;
            this.tempSlctRsrcValue[this.paging.currentPage] = this.resourceList.filter((rsrc)=>{if(selectedKey.includes(rsrc.instId))return rsrc});
            this.getSelectedResource();
        },
        closeAddingResource() {
            this.callCloseARC();
            this.resetFilter(true);
            $('body').toggleAttr('data-wing-expand', '');
        },
        toggleResourceFilter() {
            $('.setting-filter-resource').toggleAttr('data-expand', '');
        },
        clearFilter() {
            this.resetFilter();
            this.applyFilter();
        },
        resetFilter(isRefresh) {
            this.totalSlctedRsrc = [];
            this.tempSlctRsrcKeys = {};
            this.regionKeys = [];
            this.productKeys = [];
            this.accountKeys = [];
            // refresh 값이 True일때(팝업 닫을때)만 기존 필터 선택 값까지 없애버림
            if(isRefresh) {
                this.cloudKey = null;
                this.selectedFilterKeys = [];
            }
        },
        async applyFilter() {
            let accountKeys = [];
            _.forEach(this.accountKeys, (account) => {
                accountKeys.push(this.getAccountId(account));
            });
            const filterKeys = {
                cloudKey: this.cloudKey,
                productKeys: this.productKeys,
                regionKeys: this.regionKeys,
                accountKeys
            }
            await this.callApplyFilterKeys(filterKeys);
            await this.callSetCurrentPage(1);
            this.toggleResourceFilter();
        },
        toggleAllDetailFilter(isExpand){
            this.isExpandAccountFilter = isExpand;
            this.isExpandRegionFilter = isExpand;
            this.isExpandProductFilter = isExpand;
        },
        toggleDetailFilter(type){
            switch (type) {
                case 'account' :
                    this.isExpandAccountFilter = !this.isExpandAccountFilter;
                    break;
                case 'region' :
                    this.isExpandRegionFilter = !this.isExpandRegionFilter;
                    break;
                case 'product' :
                    this.isExpandProductFilter = !this.isExpandProductFilter;
                    break;
                default :
                    break;
            }
        },
    }
}
</script>

<style scoped>
.layout-wing-view {
   height: 85%;
   overflow: auto;
}
.layout-wing-view .wing-title {
    height: 5%;
}
.resource-list {
    height: 90%;
}
.layout-wing-view .wing-footer {
    height: 20%;
}
.layout-wing-view .wing-footer .wing-confirm {
    height: 30%;
}
.layout-wing-view .wing-footer .actions {
    height: 20%;
}
.search-box label {
    width: 100%;
}
.setting-filter-resource {
    top: 0;
    position: inherit;
}
.setting-filter-resource .filter-contents {
    background-color: #f6f7f8;
    position: absolute;
    z-index: 1;
    box-shadow: -4px 5px 16px 0 #888888;
    width: 100%;
}
.layout-wing-view .search-box input[type=search] {
    height: 25px;
}
.layout-wing-view .wing-contents {
    width: 1000px;
}

.layout-wing-view .wing-contents #gridData {
    height: 100%;
}
.layout-wing-view .wing-footer .wing-confirm {
    height: 35%;
    padding: 0 50px;
}
.layout-wing-view .wing-footer .actions {
    padding: 20px;
}

.paging-group {
    margin-bottom: 10px;
    margin-right: 20px;
}

.paging-group .pagination {
    position: inherit;
    width: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/settings/settingComponents/AddingResourceComponent.vue